import React, { useEffect, useState } from 'react';
import api from '../../../../Services/api';
import { Bar } from 'react-chartjs-2';
import { Doughnut } from 'react-chartjs-2';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';

import ProgressBar from 'react-bootstrap/ProgressBar'; // You can use this for the progress bar
// import ChartDataLabels from 'chartjs-plugin-datalabels';  // Import chartjs-plugin-datalabels

// Register Chart.js components
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
//   ChartDataLabels
);
const YearlyMonthlydata = ({show}) => {
    let data1 = sessionStorage.getItem('user');
    let clientData = JSON.parse(data1);
    let id = clientData.id;

    const currentYear = new Date().getFullYear();
    const [yearlyData, setYearlyData] = useState(null);
    const [vendorList, setVendorList] = useState([]);
    const[loading,setLoading] = useState(true);
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedYearForBar, setSelectedYearForBar] = useState(currentYear);
    const [selectedQuarter, setSelectedQuarter] = useState('Yearly'); // New state for selected quarter/half
    const [snackbarOpen, setSnackbarOpen] = useState(false);
              const [snackbarMessage, setSnackbarMessage] = useState('');
              const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
              const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
    

    useEffect(() => {
        const timer = setTimeout(() => {
            getData()
        }, 1000); 
      
        return () => clearTimeout(timer); 
      }, [id,selectedYear]); 


        const getData = async () => {
            const response = await api.client.getAvgDataVendors(id, selectedYear);
           if(response.status === 200){
            setYearlyData(response.data.data);
            setLoading(false)
           } else if(response.status === 404) {
            setErrorSnackbarOpen(true)
            setSnackbarErrorMessage(response.data.message);
            setYearlyData(null)
            setLoading(false)
           }
           else if(response.status === 400){
            setErrorSnackbarOpen(true)
            setSnackbarErrorMessage(response.data.message);
            setYearlyData(null)
            setLoading(false)
           }
           else if(response.status == 500){
            setErrorSnackbarOpen(true)
            setSnackbarErrorMessage(response.data.message);
            setYearlyData(null)
            setLoading(false)
           }
           else{
            setErrorSnackbarOpen(true)
            setSnackbarErrorMessage("some error occured, try again!!");
            setYearlyData(null)
            setLoading(false)
           }
        };
     

    useEffect(() => {
        const fetchVendors = async () => {
            const response = await api.client.getAllVendors(id);
            setVendorList(response.data.data.vendorProfile || []);
        };
        fetchVendors();
    }, []);

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    const handleQuarterChange = (e) => {
        setSelectedQuarter(e.target.value);
    };

    // Data for Doughnut Chart
    
    const overallAccepted = yearlyData ? parseFloat(yearlyData.overallYearlyAcceptedAvg) : 0;
    const overallRejected = yearlyData ? parseFloat(yearlyData.overallYearlyRejectedAvg) : 0;
    const overallUnderReview = yearlyData ? parseFloat(yearlyData.overallyearlyUnderReviewAvg) : 0;
    const total = overallAccepted + overallRejected + overallUnderReview;
   
    if ( total >= 100 ){
        remainingPercentage = 0;
    }else{
       var remainingPercentage = (100 - (parseFloat(overallAccepted) + parseFloat(overallRejected) + parseFloat(overallUnderReview))).toFixed(2);

    }

    const doughnutData = {
        labels: ['Accepted', 'Rejected','UnderReview','Not Uploaded'],
        datasets: [
            {
                data: [overallAccepted, overallRejected,overallUnderReview,remainingPercentage],
                backgroundColor: ['#50c878', '#B22222','#EFCC00','lightgray'],  // Green for accepted, red for rejected
                borderWidth: 0,
                
            },
        ],
    };
    const chunkData = (data, chunkSize) => {
        let result = [];
        for (let i = 0; i < data.length; i += chunkSize) {
            result.push(data.slice(i, i + chunkSize));
        }
        return result;
    };

    // Data for Bar Chart
    let vendorLabels = [];
    let combinedData = [];
  
    if (yearlyData && yearlyData.vendorAverages) {
        for (let i = 0; i < yearlyData.vendorAverages.length; i++) {
            const vendor = yearlyData.vendorAverages[i];
            const vendorName = vendorList.find(v => v.vendorId === vendor.vendorId)?.vendorCompanyName || '';
            
            vendorLabels.push(vendorName.slice(0, 5)); // Vendor names for X-axis
            // Combine the accepted and rejected data into one (you can sum or average them)
            const combinedValue = vendor.yearlyAcceptedAverage + vendor.yearlyRejectedAverage;
            combinedData.push(combinedValue);
        }
    }
    const chunkedVendorLabels = chunkData(vendorLabels, 25); // Chunk the labels
   

  
    
    const getQuarterOrHalfData = () => {
        if (yearlyData && yearlyData.vendorAverages) {
            return yearlyData.vendorAverages.map(vendor => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return vendor.Q1AcceptedAvg;
                    case 'Q2':
                        return vendor.Q2AcceptedAvg;
                    case 'Q3':
                        return vendor.Q3AcceptedAvg;
                    case 'Q4':
                        return vendor.Q4AcceptedAvg;
                    // case 'H1':
                    //     return vendor.H1AcceptedAvg;
                    // case 'H2':
                    //     return vendor.H2AcceptedAvg;
                        case 'Yearly':
                        return vendor.yearlyAcceptedAverage;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };

    const getQuarterOrHalfDataRejected = () => {
        if (yearlyData && yearlyData.vendorAverages) {
            return yearlyData.vendorAverages.map(vendor => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return vendor.Q1RejectedAvg;
                    case 'Q2':
                        return vendor.Q2RejectedAvg;
                    case 'Q3':
                        return vendor.Q3RejectedAvg;
                    case 'Q4':
                        return vendor.Q4RejectedAvg;
                    // case 'H1':
                    //     return vendor.H1RejectedAvg;
                    // case 'H2':
                    //     return vendor.H2RejectedAvg;
                        case 'Yearly':
                        return vendor.yearlyRejectedAverage;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };
    const getQuarterOrHalfDataUnderReview = () => {
        if (yearlyData && yearlyData.vendorAverages) {
            return yearlyData.vendorAverages.map(vendor => {
                switch (selectedQuarter) {
                 case 'Q1':
                        return vendor.Q1UnderReviewAvg;
                    case 'Q2':
                        return vendor.Q2UnderReviewAvg;
                    case 'Q3':
                        return vendor.Q3UnderReviewAvg;
                    case 'Q4':
                       return vendor.Q4UnderReviewAvg;
                    // case 'H1':
                    //     return vendor.H1RejectedAvg;
                    // case 'H2':
                    //     return vendor.H2RejectedAvg;
                        case 'Yearly':
                        return vendor.YearlyUnderReviewAvg;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };

    const acceptedQuarterData = getQuarterOrHalfData();
const rejectedQuarterData = getQuarterOrHalfDataRejected();
const underReviewQuarterData = getQuarterOrHalfDataUnderReview();

    return (
    <>  <Snackbar
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        severity="success"
                        open={snackbarOpen}
                        autoHideDuration={2000}
                        onClose={() => setSnackbarOpen(false)}
                        sx={{ marginTop: '2.9%', marginRight: '7%' }}
                      >
                        <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
                      </Snackbar>
                      <Snackbar
                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        severity="error"
                        open={errorSnackbarOpen}
                        autoHideDuration={2000}
                        sx={{ marginTop: '2.9%', marginRight: '7%' }}
                        onClose={() => setErrorSnackbarOpen(false)}
                      >
                        <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
                      </Snackbar>
        <div>
           
               
        {loading ? (
                  <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
                  <h3>Loading</h3>
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
         <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
         
         </div>
              ) : 

                yearlyData && yearlyData.vendorAverages ? (
    <section className="d-flex flex-column align-items-center">
        {(!show || show === "donut") && (
            <div style={{border:"1px solid lightgray",height:'380px'}}>

 <h6 className="p-3 bg-dark text-light" >Vendors Average Yearly Compliance</h6>
<section className="d-flex float-end mt-3">
<select value={selectedYear} onChange={handleYearChange} style={{cursor:'pointer',border:'1px solid lightgray'}} className=" mx-2 year-dropdown text-dark">
 {Array.from({ length: currentYear - 2020 + 1 }, (_, i) => 2020 + i).map((year) => (
         <option key={year} value={year}>
             {year}
         </option>
     ))}
 </select>
 </section>
        <div className="p-5 justify-content-center" style={{height:'300px',width:'300px'}}>
     
           {/* <h1 className="text-dark" style={{position:'relative',top:'110px',left:'88px',fontSize:'18px'}}>{overallAccepted}%</h1> */}
            <Doughnut
                data={doughnutData}
                options={{
                    cutout:'30%',
                    backgroundColor:'black',
                    responsive: true,
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    let percentage;
                                    if (context.label === 'Accepted') {
                                        percentage = overallAccepted;
                                        return `Accepted: ${percentage}%`;
                                    } else if (context.label === 'Rejected') {
                                        percentage = overallRejected;
                                        return `Rejected: ${percentage}%`;
                                    } else if (context.label === 'UnderReview') {
                                        percentage = overallUnderReview;
                                        return `UnderReview: ${percentage}%`;
                                    }
                                    else if (context.label === 'Not Uploaded') {
                                        percentage = remainingPercentage;
                                        return `Not Uploaded: ${percentage}%`;
                                    }
                                },
                            },
                        },
                        datalabels: {
                            display: true, // Enable data labels (percentages inside bars)
                            color: 'white', // White color for the percentage labels
                            align: 'center', // Align the label inside the bar
                            anchor: 'center', // Anchor the label inside the bar
                            font: {
                                size: 12, // Font size for the label
                               // Make the text bold
                            },
                            formatter: function (value) {
                                return value === 0 ? '' : `${value}%`;
                            },
                        },
                    },
                }}
            />
        </div>
        </div>
         )}
      
        
      {(show === "bar") && (
        <div className="mt-4" style={{width:'100%',border:'1px solid lightgray'}}>
        <div className="p-3 d-flex bg-dark justify-content-between w-100" >
            {/* The Doughnut Chart will be centered, and the Quarter select will be aligned to the right */}
            <div>
            <h6 className="mx-2 text-light" > Vendor Wise Average Compliance</h6>
            </div>
            <div> {/* Empty div to push the select dropdown to the right */}
            <select value={selectedYear} onChange={handleYearChange} style={{cursor:'pointer'}} className=" mx-2 year-dropdown text-dark bg-light">
 {Array.from({ length: currentYear - 2020 + 1 }, (_, i) => 2020 + i).map((year) => (
         <option key={year} value={year}>
             {year}
         </option>
     ))}
 </select>
            <select 
                value={selectedQuarter} 
                onChange={handleQuarterChange} 
                className="mx-2 quarter-dropdown" 
                style={{color:"black", cursor:'pointer'}}
            >
                {['Yearly', 'Q1', 'Q2', 'Q3', 'Q4'].map((quarter) => (
                    <option key={quarter} value={quarter}>
                        {quarter}
                    </option>
                ))}
            </select>
            </div>
        </div>

       {chunkedVendorLabels.map((chunk, index) => {
            return (
            <div style={{ height: '350px' }}>
        <Bar
    className="w-100"
  
    key={index}
    
    data={{
        labels: chunk, // Vendor names for the X-axis
        datasets: [
            {
                label: 'Accepted',
                data: acceptedQuarterData,  // Data for "Accepted"
                backgroundColor: '#3CB371', // Green color for "Accepted"
                borderColor: '#50c878',
                borderRadius: 0, // No border radius
                borderWidth: 0,
                barThickness: 25, 
                stack: 'stack1'// Set bar thickness for accepted bars
             
            },
        
            {
                label: 'UnderReview',
                data: underReviewQuarterData,  // Data for "Accepted"
                backgroundColor: '#EFCC00', // Green color for "Accepted"
                borderColor: '#EFCC00',
                borderRadius: 0, // No border radius
                borderWidth: 0,
                barThickness: 25,
                stack: 'stack1' // Set bar thickness for accepted bars
             
            },
            {
                label: 'Rejected',
                data: rejectedQuarterData,  // Data for "Rejected"
                backgroundColor: '#B22222', // Red color for "Rejected"
                borderColor: '#B22222',
                borderRadius: 0, // No border radius
                borderWidth: 0,
                barThickness: 25,
                stack: 'stack1' // Set bar thickness for rejected bars
             
            },
        ],
    }}
    options={{
        responsive: true,
          maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false, // Hide grid lines for X-axis
                },
                ticks: {
                    display: true,
                    color: 'gray',
                    font: {
                        size: 10,
                    },
                    maxRotation: 45,
                    minRotation: 30,
                },
            },
            y: {
                min: 0,
                  max: 100, // Start the Y-axis from 0%
                grid: {
                    display: false, // Show grid lines for Y-axis
                },
                ticks: {
                    display: false, // Show ticks on Y-axis
                    stepSize: 10, // Control the step size for ticks
                    callback: function(value) {
                        return value + '%'; // Format Y-axis ticks as percentage
                    },
                },
              
                stacked: true, 
            },
        },
        plugins: {
            legend: {
                display: false, // Disable the legend
            },
            title: {
                display: true,
            },
            tooltip: {
                callbacks: {
                    label: function(tooltipItem) {
                        const vendor = yearlyData.vendorAverages[tooltipItem.dataIndex];
                        const fullVendorName = vendorList.find(v => v.vendorId === vendor.vendorId)?.vendorCompanyName || '';
                        const acceptedValue = acceptedQuarterData[tooltipItem.dataIndex]; // Correct data access for Accepted
                        const rejectedValue = rejectedQuarterData[tooltipItem.dataIndex]; // Correct data access for Rejected
                        const underReviewValue = underReviewQuarterData[tooltipItem.dataIndex]
                        if (tooltipItem.datasetIndex === 0) {
                            // Dataset 0 represents Accepted
                            return `${fullVendorName}: Accepted ${acceptedValue}%`;
                        } else if(tooltipItem.datasetIndex === 1){
                            // Dataset 1 represents Rejected
                            return `${fullVendorName}: UnderReview ${underReviewValue}%`;
                        }
                        else{
                            return `${fullVendorName}: Rejected ${rejectedValue}%`;
                        }
                    }
                },
            },
            datalabels: {
                display: true, // Enable data labels
                color: 'white', // Text color for the percentage labels
                align: 'center', // Align the label at the center of the bar
                font: {
                    size: 10, // Font size for the percentage labels
                },
                rotation: -50,
                formatter: function (value, context) {
                    let roundedValue;
                    if (context.datasetIndex === 0) {
                        // For Accepted bars, show the accepted percentage
                        const acceptedValue = acceptedQuarterData[context.dataIndex];
                        roundedValue = acceptedValue;
                        if(roundedValue!=0)
                        return `${roundedValue}%`; 
                    } else if(context.datasetIndex === 2){
                        // For Rejected bars, show the rejected percentage
                        const rejectedValue = rejectedQuarterData[context.dataIndex];
                        roundedValue = rejectedValue;
                        if(roundedValue!=0) {// Show percentage for the "Rejected" bar
                        return `${roundedValue}%`
                    }
                }
                    else if(context.datasetIndex === 1){
                        // For Rejected bars, show the rejected percentage
                        const underReviewValue = underReviewQuarterData[context.dataIndex];
                        roundedValue = underReviewValue;
                        if(roundedValue!=0) {// Show percentage for the "Rejected" bar
                        return `${roundedValue}%`
                    }
                }
                        return ''; // Show percentage for the "Rejected" bar
                    
                },
            },
        },
    }}
/>
</div>
            )})}
            </div>
        )}




    </section>
) : (
    <div className="text-center text-danger p-5">
    Monthly Data not created for the selected Year!!
    <select value={selectedYear} onChange={handleYearChange} className="mx-3 year-dropdown text-light bg-dark" style={{ cursor: 'pointer', border: '1px solid lightgray' }}>
        {Array.from({ length: currentYear - 2020 + 1 }, (_, i) => 2020 + i).map((year) => (
            <option key={year} value={year}>
                {year}
            </option>
        ))}
    </select>
</div>
)


}


        </div>
        </>
    );
};

export default YearlyMonthlydata;
